module.exports = __webpack_public_path__ + "static/img/dress_belt_defalut.5a97bcb6.png";